import "../styles/NewCards.css";

export default function NewCards(props) {
  console.log(props);
  return (
    <a
      className="project-card"
      href={props.link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="project-card__media">
        <img src={props.src} alt={`Screenshot of the ${props.info} project`} />
        <div class="project-card__overlay"></div>
      </div>
      <div className="project-card__body">
        <div class="project-card__tags">
          {props.tags.map((tag, index) => (
            <span key={index} class="tag">
              {tag[0].toUpperCase() + tag.slice(1)}
            </span>
          ))}
        </div>
        <div class="project-card__text">
          <h3 class="project-card__title">{props.info}</h3>
          <p class="project-card__desc">{props.about}</p>
        </div>
        <div class="project-card__cta">
          <span>View project</span>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            width="16"
            height="16"
          >
            <path d="M7 7h10v10" />
            <path d="M7 17 17 7" />
          </svg>
        </div>
      </div>
    </a>
  );
}
